import { Platform } from '@angular/cdk/platform';

import { ChangeDetectorRef, Component, Input, OnInit, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { ACCOUNT_SECTIONS } from 'src/app/componenets/my-account/account-sections';
import { DeviceDetectorService } from 'ngx-device-detector';
import { HeaderStickyFrontOfficeComponent } from 'src/app/componenets/header-sticky/header-sticky-front-office/header-sticky-front-office.component';
import { DialogContentNewsLetter } from 'src/app/componenets/newsletter-dialog/dialog-content-newsletter';
import { PublicHomeComponent } from 'src/app/componenets/public-home/public-home.component';
import { AuthService } from 'src/app/services/auth.service';
import { pathRoutingEnum } from 'src/assets/constantEnum';

@Component({
    selector: 'app-nav-bar-footer-mobile',
    templateUrl: './nav-bar-footer-mobile.component.html',
    styleUrls: ['./nav-bar-footer-mobile.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NavBarFooterMobileComponent implements OnInit, OnDestroy {

  readonly accountSections = ACCOUNT_SECTIONS;

  @Input() publicHomeComponent: PublicHomeComponent = new PublicHomeComponent(this.deviceService);
  @Input() headerStickyFrontOfficeComponent!: HeaderStickyFrontOfficeComponent;
  acceptNewsLetter: boolean = false;
  email!: string;
  cookiesNewsletter!: string | null;
  isIOS: boolean = false;
  static readonly DEFAULT_AVATAR = 'assets/userAvatar.svg';
  isLoggedIn = false;
  userAvatar = NavBarFooterMobileComponent.DEFAULT_AVATAR;
  private userSubscription?: Subscription;
  private routerSubscription?: Subscription;
  activeItem: 'home' | 'nearby' | 'account' | 'menu' | null = null;

  constructor(private deviceService: DeviceDetectorService,
    private router: Router,
    public dialog: MatDialog,
    private platform: Platform,
    private authService: AuthService) {
  }

  ngOnInit(): void {
    this.updateActiveItem(this.router.url);
    this.routerSubscription = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(event => this.updateActiveItem(event.urlAfterRedirects));
    this.userSubscription = this.authService.currentUser$.subscribe((user) => {
      this.isLoggedIn = !!user;
      this.userAvatar = user?.avatar || NavBarFooterMobileComponent.DEFAULT_AVATAR;
    });
    this.isIOS = this.platform.IOS;
    this.cookiesNewsletter = localStorage.getItem('cookies_newsletter');
    if (this.cookiesNewsletter == null || this.cookiesNewsletter === "") {
      this.cookiesNewsletter = "2";
      this.setConsent("2");
    }
  }

  onScrollToHeader() {
    if (this.headerStickyFrontOfficeComponent.isDisplaySearch) {
      this.publicHomeComponent.scrollToTop();
      this.headerStickyFrontOfficeComponent.isDisplaySearch = false;
      if (this.router.url === pathRoutingEnum.dashboard.valueOf()) {
        this.router.navigate([pathRoutingEnum.promotion.valueOf()]);
      } else {
        this.router.navigate([pathRoutingEnum.dashboard.valueOf()]);
      }
    } else if (this.router.url === pathRoutingEnum.dashboard.valueOf() || this.router.url === pathRoutingEnum.promotion.valueOf()) {
      {
        this.publicHomeComponent.scrollToTop();
      }
    } else {
      this.router.navigate([pathRoutingEnum.dashboard.valueOf()]);
    }
    this.headerStickyFrontOfficeComponent.search = "";

  }

  ngOnDestroy(): void {
    this.userSubscription?.unsubscribe();
    this.routerSubscription?.unsubscribe();
  }

  // Icône surlignée dans la barre
  private updateActiveItem(url: string): void {
    const path = url.split(/[?#]/)[0];
    if (path === pathRoutingEnum.dashboard.valueOf() || path === pathRoutingEnum.promotion.valueOf()
      || path === pathRoutingEnum.promotionCode.valueOf()) {
      this.activeItem = 'home';
    } else if (path === pathRoutingEnum.nearby.valueOf()) {
      this.activeItem = 'nearby';
    } else if (path === '/' + pathRoutingEnum.menuMobile.valueOf()) {
      this.activeItem = 'menu';
    } else if (path.startsWith('/compte') || path.startsWith('/settings')) {
      this.activeItem = 'account';
    } else {
      this.activeItem = null;
    }
  }

  openDialogLogin(): void {
    this.headerStickyFrontOfficeComponent.openDialogLogin();
  }

  logout(): void {
    this.authService.logout();
  }

  onDisplaySearch() {
    this.headerStickyFrontOfficeComponent.isDisplaySearch = true;
  }

  OpenMenuMobile() {
    if (this.router.url === pathRoutingEnum.menuMobile.valueOf()) {
      this.router.navigate([pathRoutingEnum.dashboard.valueOf()]);
    } else {
      this.redirectTo(pathRoutingEnum.menuMobile.valueOf())
    }
    this.headerStickyFrontOfficeComponent.isDisplaySearch = false;
  }

  redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri]));
  }





  public openDialogNewsLetter(): void {
    const dialogRef = this.dialog.open(DialogContentNewsLetter, {
      width: '450px',
      data: { acceptNewsLetter: this.acceptNewsLetter, email: this.email },
    });

    dialogRef.afterClosed().subscribe(result => {
      this.acceptNewsLetter = result?.acceptNewsLetter;
      this.email = result?.email;
      if (result === false) {
        this.setConsent("0");
        this.cookiesNewsletter = "0";
      } else {
        this.setConsent("1");
        this.cookiesNewsletter = "1";
      }
    });

  }

  public setConsent(value: any): void {
    localStorage.setItem('cookies_newsletter', value);
  }

}
